import dataUrlToFile from './dataUrlToFile';
import errorHandling from './errorHandling';
import getValidationErrors from './getValidationErrors';

export default {
  dataUrlToFile,
  errorHandling,
  getValidationErrors,
};
